import { Stack } from 'common/ui/Layout';
import Text from 'common/ui/Text';
import { Ellipsis } from 'common/ui/Ellipsis';
import { MacroPill } from 'domains/reporter/Macro/components';

type RightDrawerMacroHeaderProps = {
  macroName: string;
  compact?: boolean;
};

export const RightDrawerMacroHeader = ({
  macroName,
  compact = false,
}: RightDrawerMacroHeaderProps): React.ReactElement => {
  return (
    <Stack alignY="center" alignX="between">
      <Stack alignY="center" space="small" css={{ minWidth: 0, flex: 1 }}>
        <Text variant="display1" css={{ minWidth: 0 }}>
          <Ellipsis>{macroName}</Ellipsis>
        </Text>
        <MacroPill label="Macro" size={compact ? 'xs' : 'sm'} />
      </Stack>
    </Stack>
  );
};
